import { ApiCore } from "@/services/api/utils/core.js";

const url = "v1/public_key";

class Publickey extends ApiCore {
	constructor(options) {
		super(options);
	}
}

const publickey = new Publickey({
	index: true,
	url,
});

export default publickey;
